// Granular API error codes. App and domain endpoints put them in
// error.details.code (ApiError.details). Duck-typed so pure modules can use
// this without importing lib/api.

/** `details.code` of an API error, if it has one. */
export function errorDetailCode(err: unknown): string | undefined {
  if (!(err instanceof Error)) return undefined;
  const details = (err as { details?: unknown }).details;
  if (details === null || typeof details !== 'object') return undefined;
  const code = (details as { code?: unknown }).code;
  return typeof code === 'string' ? code : undefined;
}

/** A friendly text, or a function of the server's message, per details.code. */
export type ErrorMessages = Readonly<Record<string, string | ((serverMessage: string) => string)>>;

/** Known codes get their friendly text; anything else the server's message, or `fallback` without one. */
export function friendlyApiError(err: unknown, messages: ErrorMessages, fallback: string): string {
  const server = err instanceof Error ? err.message.trim() : '';
  const code = errorDetailCode(err);
  const known = code !== undefined && Object.hasOwn(messages, code) ? messages[code] : undefined;
  if (typeof known === 'string') return known;
  if (known) return known(server || fallback);
  return server || fallback;
}
